module.exports = __webpack_public_path__ + "static/media/crewitem_ic.54677a62.svg";